import CardComponent from "./CardComponent";

export class CategoryPills extends CardComponent {

}
